import React from "react";
import { useDispatch } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { setsearch } from "../../redux/actions/menu";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const SearchBar = (props) => {
  const { className } = props;
  const navigate = useNavigate();
  const { outlet, table } = useParams();

  const { search, activeFilter } = useSelector((state) => state.menu);
  const dispatch = useDispatch();

  return (
    <div className={`search-bar ${className}`}>
      <SearchIcon fontSize="small" />
      <input
        type="text"
        placeholder="Search Menu..."
        value={search}
        onChange={(e) => {
          // activeFilter.length && dispatch(resetFilter([]));
          dispatch(setsearch(e.target.value));
        }}
        onFocus={() => {
          navigate(table ? `/${outlet}/${table}` : `/${outlet}`);
        }}
      />
      {search && (
        <div className="cross" onClick={() => dispatch(setsearch(""))}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
};

export default SearchBar;
